import { useQuery } from '@tanstack/react-query';
import type { ChannelConnectionDetails } from '@troia-v3/types';
import { channelsApi } from '../services/channelsApi';

/**
 * Busca o token atual + webhook URL de um canal oficial.
 * Condicionado a `enabled` (ex.: só quando o modal de reconexão está aberto).
 * Sem refetch agressivo — o token não muda durante a sessão do modal.
 */
export const useChannelConnectionDetails = (channelId: string | undefined, enabled: boolean) => {
  return useQuery<ChannelConnectionDetails>({
    queryKey: ['channel-connection-details', channelId],
    queryFn: () => channelsApi.getConnectionDetails(channelId as string),
    enabled: enabled && !!channelId,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    retry: false,
  });
};
